// extracted by mini-css-extract-plugin
export default {"ErrorContainer":"AppInit__ErrorContainer__1IT9F","ErrorTitle":"AppInit__ErrorTitle__3d9As","ErrorText":"AppInit__ErrorText__SwFae"};